import { useGetMerchantFeatureFlags } from "./queries/useMerchantQueries";

// Single source of truth for whether merchant admins can split an inflow
// transaction to another channel. Strict `=== true` so loading/error states
// fail closed (hidden) rather than flashing the action before the flag
// resolves.
export function useSplitTransactionEnabled() {
  const { data: featureFlags } = useGetMerchantFeatureFlags();
  return featureFlags?.splitTransaction === true;
}

export default useSplitTransactionEnabled;
